<script setup lang="ts">
import { defineProps } from "vue";
import { HuangHeiDaoInfo } from "@/types/calculators";

defineProps<{
  huangHeiDaoInfo: HuangHeiDaoInfo;
}>();
</script>

<template>
  <span
    class="px-2 py-0.5 rounded text-[11px] font-bold"
    :class="
      huangHeiDaoInfo.path_type === 'HuangDao'
        ? 'bg-[#EAF7EE] text-success'
        : 'bg-secondary text-alternative-gray'
    "
  >
    {{ huangHeiDaoInfo.name }}
    {{
      $t(
        huangHeiDaoInfo.path_type === "HuangDao"
          ? "calculators.personal-date.full-day-report.hourlyTable.huangDao"
          : "calculators.personal-date.full-day-report.hourlyTable.heiDao"
      )
    }}
  </span>
</template>
